// see: https://app.clickup.com/t/2628858/SANC-338
const SESSION_FLAG_KEY = 'sancare:client-info:reported'

type ClientInfo = Record<string, unknown>

function collectClientInfo(): ClientInfo {
  const w = window as unknown as Record<string, unknown>

  // En iframe cross-origin, lire window.top lance une SecurityError
  let windowTopIsSelf: boolean | 'cross-origin-throw'
  try {
    windowTopIsSelf = window.top === window.self
  } catch {
    windowTopIsSelf = 'cross-origin-throw'
  }

  return {
    userAgent: navigator.userAgent,
    windowTopIsSelf,
    globals: {
      hasCefQuery: typeof w.cefQuery !== 'undefined',
      hasQt: typeof w.qt !== 'undefined',
    },
    ux: {
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      devicePixelRatio: window.devicePixelRatio,
      prefersDarkMode: window.matchMedia('(prefers-color-scheme: dark)').matches,
    },
  }
}

export async function reportClientInfo(): Promise<void> {
  if (sessionStorage.getItem(SESSION_FLAG_KEY) === '1') {
    return
  }

  try {
    await fetch('/api/debug/client-info', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(collectClientInfo()),
      credentials: 'same-origin',
    })
    sessionStorage.setItem(SESSION_FLAG_KEY, '1')
  } catch {
    return
  }
}
